import moment from "moment";
import React from 'react';
import _ from 'lodash';
import { convertRequestPriorityToDislayValue } from "../helpers/createContentRequest";
import MyPATTruncateText from "../../common/MyPATTruncateText";
import { Subject } from "../types/ContentRequest";
import { RouteComponentProps } from "react-router";
import { dateService } from "../../common";

let dTopNavContent = [
    {
        icon: "/assets/svg/contentRequest/priority.svg",
        label: "Priority",
        subLabel: "Important but not urgent",
        color: "blue"
    },
    {
        icon: "/assets/svg/contentRequest/deadline.svg",
        label: "Deadline",
        subLabel: "11th Nov 2020",
        color: "blue"
    },
    {
        icon: "/assets/svg/contentRequest/goal.svg",
        label: "Goal",
        subLabel: "JEE Mains",
        color: "blue"
    },
    {
        icon: "/assets/svg/contentRequest/subject.svg",
        label: "Subject",
        subLabel: "Physics",
        color: "blue"
    },
    {
        label: "Assigned by",
        subLabel: "JK Rai",
    },
];
interface TopNavValues{
    Priority:string;
    Deadline:string;
    Goal:string|React.ReactNode;
    Subject:string|React.ReactNode;
    "Assigned by" : string
}
let topNavValue:TopNavValues = {
    "Priority": '',
    "Deadline": '',
    "Goal": '',
    "Subject": '',
    "Assigned by": '',
}



export const handleDTopNavContent = (props: any, relevantSubjects: Subject[]): any => {

    dTopNavContent.map((content: any, index: number) => {
        const { label = '' } = content;
        const { contentRequestStateData: { requestInfo = {} } = {} } = props;
        const authorType =props.match.params.role;
        const endDate = requestInfo.owners[0].roles[authorType].endDate;
        switch (label) {
            case 'Priority':
                const { priority = '' } = requestInfo;
                const priorityDisplayValue = convertRequestPriorityToDislayValue(priority);
                topNavValue = { ...topNavValue, "Priority": priorityDisplayValue };
                break;
            case 'Deadline':
                let endDate = _.get(requestInfo, "owners[0].roles.creator.endDate", "")
                content = { ...content, subLabel: endDate ? dateService.dateFromString(endDate) : 'NA' };
                topNavValue = { ...topNavValue, "Deadline": endDate ? dateService.dateFromString(endDate) : 'NA' };
                break;
            case 'Goal':
                const { details: { courseTypes = [] } = {} } = requestInfo;
                const name =  <MyPATTruncateText data={courseTypes.map((ele: any) => ele.name)} truncateLength= {11} displayCount= {2}/>
                topNavValue = { ...topNavValue, "Goal": name};
                break;
            case 'Subject':
                topNavValue = { ...topNavValue, "Subject":  <MyPATTruncateText data={relevantSubjects.map((subject:any)=>subject.name)} truncateLength= {11} displayCount= {2}/> };
                break;
            case 'Assigned by':
                const assignedBy = _.get(relevantSubjects, '[0].assignor.name', 'NA')
                topNavValue = { ...topNavValue, "Assigned by": assignedBy };
                break;
            default: {
                break;
            }
        }
    })
    return topNavValue;
}